import { SvgImage } from '@/modules/ProductPage/components/Footer/type/SvgImage';

export const providerImageData: SvgImage[] = [
  { alt: 'dhl icon', src: '/images/footer/providers/dhl.svg' },
  { alt: 'ups icon', src: '/images/footer/providers/ups.svg' },
  { alt: 'fedex icon', src: '/images/footer/providers/fedex.svg' },
];
